import type { IJourney } from '../../../../../../../../models/journey.model';
import { LegHelper } from '../../../../../../../../helpers/leg.helper';
import { TranslationService } from '../../../../../../../../services/translation.service';
import { JourneyHelper } from '../../../../../../../../helpers/journey.helper';
import { DateTimeHelper } from '../../../../../../../../helpers/date-time.helper';
import { DateTime } from 'luxon';

function PrintSummary({ journey, className }: { journey: IJourney; className?: string }) {
  const getFromLocation = (): string => {
    return journey.destinationLink ? journey.destinationLink.origin.name : journey.tripLegs && journey.tripLegs.length > 0 ? journey.tripLegs[0].origin.stopPoint.name : '';
  };

  const getToLocation = (): string => {
    const lastTripLegDestinationName = journey.tripLegs && journey.tripLegs.length > 0 ? journey.tripLegs[journey.tripLegs.length - 1].destination.stopPoint.name : '';
    return journey.destinationLink ? journey.destinationLink.destination.name : lastTripLegDestinationName;
  };

  const fromLocation = getFromLocation();
  const toLocation = getToLocation();

  function getDepartureTime(): DateTime | undefined {
    if (journey.destinationLink) return journey.destinationLink.origin.plannedTime;
    return journey.departureAccessLink
      ? journey.departureAccessLink.origin.plannedTime
      : journey.tripLegs && journey.tripLegs.length > 0
      ? LegHelper.getDepartureTime(journey.tripLegs![0], true)
      : undefined;
  }

  function getArrivalTime(): DateTime | undefined {
    if (journey.destinationLink) return journey.destinationLink.destination.plannedTime;
    return journey.arrivalAccessLink
      ? journey.arrivalAccessLink.destination.plannedTime
      : journey.tripLegs && journey.tripLegs.length > 0
      ? LegHelper.getArrivalTime(journey.tripLegs![journey.tripLegs!.length - 1], true)
      : undefined;
  }

  // === VARIABLES ===
  const departureTime = getDepartureTime();
  const arrivalTime = getArrivalTime();

  // === RENDERING ===
  return (
    <div className={`position-relative d-none d-print-block ${className ?? ''}`}>
      <ul className="list-unstyled">
        <li>
          <span className="fw-bold">{TranslationService.get('common.from')}:&nbsp;</span>
          <span>{fromLocation}</span>
        </li>
        <li className="mb-2">
          <span className="fw-bold">{TranslationService.get('common.to')}:&nbsp;</span>
          <span>{toLocation}</span>
        </li>
        <li>
          <span className="fw-bold">{TranslationService.get('common.date')}:&nbsp;</span>
          <span>{DateTimeHelper.toLongDate(departureTime)}</span>
        </li>
        <li>
          <span className="fw-bold">{TranslationService.get('common.departure')}:&nbsp;</span>
          <span>{DateTimeHelper.toTime(departureTime)}</span>
        </li>
        <li className="mb-2">
          <span className="fw-bold">{TranslationService.get('common.arrival')}:&nbsp;</span>
          <span>{DateTimeHelper.toTime(arrivalTime)}</span>
        </li>
        <li>
          <span className="fw-bold">{TranslationService.get('common.traveltime')}:&nbsp;</span>
          <span>{departureTime && arrivalTime ? DateTimeHelper.toDuration(departureTime, arrivalTime) : ''}</span>
        </li>
        {JourneyHelper.getNumberOfInterchanges(journey) > 0 && (
          <li>
            <span className="fw-bold">{TranslationService.get('common.interchanges')}:&nbsp;</span>
            <span>{JourneyHelper.getNumberOfInterchanges(journey)}</span>
          </li>
        )}
      </ul>
      <hr className="border-top border-top-wide border-gray border-dotted" />
    </div>
  );
}

export default PrintSummary;
